import { selectLaunchableJourneyIdsSorted } from '../selectors/config'
import type { JourneySelectAction } from '../types/actions'

import { actionFactory } from './factory'
import { journeyReset } from './journeyReset'

export const journeySelect = actionFactory<JourneySelectAction>(
  (state, { id }) => {
    const allowedIds = selectLaunchableJourneyIdsSorted(state)

    if (allowedIds.includes(id)) {
      state.selectedJourneyId = id
      journeyReset(undefined, state)
    }
  },
  'journeySelect'
)
